import React from 'react';
import classes from './linkBlock.module.css';
import { Container } from "react-bootstrap";
import ListList from "../list/listList";

const ModuleItem = (props) => {
    return(
        <Container fluid="md">
            <div className={props.item.class}>
                <div className={classes.imgBlock}>
                    <img src={props.item.src} alt="img-module" />
                </div>
                <div className={classes.contentModule}>
                    <h3>{props.item.title}</h3>
                    <div className={classes.divaider}></div>
                    <p>{props.item.body}</p>
                    <ul className={classes.listBlock}>
                        <ListList lists={props.lists}/>
                    </ul>
                </div>
            </div>
        </Container>
    )
}

export default ModuleItem;